import { IObservable, Subject } from '~/rage/utils';
import { IBetaRewards, IBetaRewardsService } from './betaRewardsServiceTypes';

export class BetaRewardsServiceStub implements IBetaRewardsService {
	private readonly reward = new Subject<IBetaRewards>({
		money: 250_000,
		donate: 500,
	});

	public getReward(): IObservable<IBetaRewards> {
		return this.reward;
	}

	public async claimReward(): Promise<void> {
		console.log('BetaRewardsService: claimReward');
	}

	public async close(): Promise<void> {
		console.log('BetaRewardsService: close');
	}
}
